export enum StakeType {
  Staked = 1,
  CoolDown = 2,
  Redeem = 3,
}
